// extracted by mini-css-extract-plugin
export default {"root":"stats-table_root__xt5cB"};